import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { optInFeaturesQueryKeys } from '../Constants/queryKeys';
import { getOptInFeatureUsers } from '../Services/OptInFeatures.service';
import type { OptInFeatureUsersRequest } from '../Types/OptInFeatures.types';

/**
 * One page of the people who ever turned the feature on.
 *
 * Keeps the previous page on screen while the next one loads, so paging does not collapse the
 * table to a spinner and back.
 */
export const useOptInFeatureUsers = (id: string | undefined, params: OptInFeatureUsersRequest) =>
  useQuery({
    queryKey: optInFeaturesQueryKeys.users(id ?? '', params),
    queryFn: () => getOptInFeatureUsers(id ?? '', params),
    enabled: Boolean(id),
    placeholderData: keepPreviousData,
  });
